import React, { useEffect } from 'react';
import StylistCard from '../../components/StylistCard';

function MobileStylistLayout({ stylists }) {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
      .hide-scrollbar {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }
      .scroll-snap-x {
        scroll-snap-type: x mandatory;
      }
      .scroll-snap-align-start {
        scroll-snap-align: start;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div className="relative">
      <div className="overflow-x-scroll hide-scrollbar scroll-snap-x touch-pan-x">
        <div className="flex space-x-4">
          {stylists.map((stylist, index) => (
            <div 
              key={index} 
              className="flex-none w-[220px] scroll-snap-align-start" 
            >
              <StylistCard {...stylist} />
            </div>
          ))}
        </div>
      </div>
      <div className="mt-4 text-center text-sm text-gray-500">
        Geser untuk melihat lebih banyak
      </div>
    </div>
  );
}

export default MobileStylistLayout;